const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const GET_PAYMENT_OPTIONS = 'GET_PAYMENT_OPTIONS';
const PAYMENT_OPTIONS_RECEIVED = 'PAYMENT_OPTIONS_RECEIVED';
const IS_NON_3D_RECEIVED = 'IS_NON_3D_RECEIVED';
const ADD_CARD_DETAILS_TO_CART = 'ADD_CARD_DETAILS_TO_CART';
const GET_APPLE_PAY_SESSION = 'GET_APPLE_PAY_SESSION';
const PROCESS_APPLE_PAY_SESSION = 'PROCESS_APPLE_PAY_SESSION';
const API_SUCCESS_CODE = '1';
const ASYNC_FETCH_FAILURE = 'ASYNC_FETCH_FAILURE';
const PAYPAL_LOGIN = 'PAYPAL_LOGIN';
const ASYNC_FETCH_INVALIDATE = 'ASYNC_FETCH_INVALIDATE';
const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
const ERR_RECEIVED = 'ERR_RECEIVED';
const UPDATE_3DS_INFO = 'UPDATE_3DS_INFO';
const HANDLE_3D_PAYMENT_VALIDATED = 'HANDLE_3D_PAYMENT_VALIDATED';
const SAVE_CARD_DETAILS = 'SAVE_CARD_DETAILS';
const GET_PAYPAL_DETAILS_FROM_CART = 'GET_PAYPAL_DETAILS_FROM_CART';
const IS_PAYPAL_CHOOSEN = 'IS_PAYPAL_CHOOSEN';
const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
const SHOW_WARN_ERROR = 'SHOW_WARN_ERROR';
const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
const GET_CART_DETAILS_PAYMENT = 'GET_CART_DETAILS_PAYMENT';
const PAYMENT_SUCESS = 'PAYMENT_SUCESS';
const CONFIRM_SUBMIT_CALL = 'CONFIRM_SUBMIT_CALL';
const REDIRECT_DONE = 'REDIRECT_DONE';
const SELECTED_PAYMENT = 'SELECTED_PAYMENT';
const UPDATE_APPLE_MERCHANT_SESSION = 'UPDATE_APPLE_MERCHANT_SESSION';
const GET_PAYMENT_ZIP_DETAILS = 'GET_PAYMENT_ZIP_DETAILS';
const PAYMENT_ZIP_DETAILS_FAILED = 'PAYMENT_ZIP_DETAILS_FAILED';
const SHOW_PAYMENT_API_ERROR = 'SHOW_PAYMENT_API_ERROR';
const UPDATE_APPLE_PAY_PROCESS_SESSION_STATUS = 'UPDATE_APPLE_PAY_PROCESS_SESSION_STATUS';
const SET_PAYPAL_ERROR = 'SET_PAYPAL_ERROR';
const RESET_PAYPAL_ERROR = 'RESET_PAYPAL_ERROR';
const MAX_ATTEMPT_ERROR = 'MAX_ATTEMPT_ERROR';
const CEF_PAYMENT_INFO_ERROR = 'CEF_PAYMENT_INFO_ERROR';
const CEF_CHECKOUT_DETAILS_ERROR = 'CEF_CHECKOUT_DETAILS_ERROR';
const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
const SET_CLIENT_TOKEN = 'SET_CLIENT_TOKEN';
const FETCH_CLIENT_TOKEN = 'FETCH_CLIENT_TOKEN';
const PROCESS_BRAINTREE_PAYMENT = 'PROCESS_BRAINTREE_PAYMENT';
const PAYMENT_BRAINTREE_FAILURE = 'PAYMENT_BRAINTREE_FAILURE';
const TRIGGER_FROM_PAYMENT_NSE = 'redirecttonextgenpayment_nse';
const PAYMENT_TYPE = 'braintreeAuthentication';
const BRAINTREE_CHECKOUT = 'braintreeCheckout';
const PAYMENT_BRAINTREE_FAILURE_MESSAGE = "We encountered an error while processing your request. Please try again later.";
export {
  GET_DATA_FROM_API,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_DATA_SUCCESS,
  ERR_OCCURED,
  GET_PAYMENT_OPTIONS,
  PAYMENT_OPTIONS_RECEIVED,
  IS_NON_3D_RECEIVED,
  GET_APPLE_PAY_SESSION,
  PROCESS_APPLE_PAY_SESSION,
  API_SUCCESS_CODE,
  PAYPAL_LOGIN,
  ASYNC_FETCH_FAILURE,
  ASYNC_FETCH_INVALIDATE,
  DEFAULT_ERR_MSG,
  ERR_RECEIVED,
  ADD_CARD_DETAILS_TO_CART,
  UPDATE_3DS_INFO,
  HANDLE_3D_PAYMENT_VALIDATED,
  SAVE_CARD_DETAILS,
  GET_PAYPAL_DETAILS_FROM_CART,
  IS_PAYPAL_CHOOSEN,
  GET_CART_SUCCESS,
  SHOW_WARN_ERROR,
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  GET_CART_DETAILS_PAYMENT,
  PAYMENT_SUCESS,
  CONFIRM_SUBMIT_CALL,
  REDIRECT_DONE,
  SELECTED_PAYMENT,
  UPDATE_APPLE_MERCHANT_SESSION,
  GET_PAYMENT_ZIP_DETAILS,
  PAYMENT_ZIP_DETAILS_FAILED,
  SHOW_PAYMENT_API_ERROR,
  UPDATE_APPLE_PAY_PROCESS_SESSION_STATUS,
  SET_PAYPAL_ERROR,
  RESET_PAYPAL_ERROR,
  MAX_ATTEMPT_ERROR,
  CEF_PAYMENT_INFO_ERROR,
  CEF_CHECKOUT_DETAILS_ERROR,
  DEFAULT_ERROR_MESSAGE,
  SET_CLIENT_TOKEN,
  FETCH_CLIENT_TOKEN,
  PROCESS_BRAINTREE_PAYMENT,
  PAYMENT_BRAINTREE_FAILURE,
  TRIGGER_FROM_PAYMENT_NSE,
  PAYMENT_TYPE,
  BRAINTREE_CHECKOUT,
  PAYMENT_BRAINTREE_FAILURE_MESSAGE,
};
